import React, { 
	useRef, 
	useEffect,
	useState,
	//useState 
} from "react";
import { connect } from "react-redux";

import { CalcitePanel, CalciteShellCenterRow } from "@esri/calcite-components-react";
//import { ResponsiveLine } from '@nivo/line'

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more'; 

import { graphClosed, graphIsRendered } from "../../../../../Flux/actions";
//import * as watchUtils from "@arcgis/core/core/watchUtils";

const GraphCenterPanel = ({graphingOptions, closeGraphWindow, setGraphIsRendered}) => {

	const [options, SetOptions] = useState({
		title: {
		  text: 'My chart'
		},
		series: []
	  });
	
	const panelRef = useRef(null);
	const highchartsRef = useRef(null);
	

	useEffect( () => {
		
		if( graphingOptions.isGraphOpen && !graphingOptions.isRendered ) {
			//Timeout helps with rendering. I'm not sure this is a great idea but otherwise highcharts won't properly fill the area.
			setTimeout( ()=> {
				SetOptions(graphingOptions.chartObject);
				setGraphIsRendered();
			}, 1);
			setTimeout( ()=> {
				if( highchartsRef.current ) {
					highchartsRef.current.chart.reflow();
				}
			}, 1);
		}
	}, [graphingOptions, setGraphIsRendered] );

	if( !graphingOptions.isGraphOpen) {
		return null;
	}
	 
	
	highchartsMore(Highcharts);
	return (
		<CalciteShellCenterRow className="center-row" slot="center-row" detached={true} position="end">
			<CalcitePanel style={{maxHeight:'50vh'}} loading={!graphingOptions.isRendered }
				ref={panelRef}
				dismissible={true}
				heading="Graph"
				onCalcitePanelDismissedChange={(e) => { console.warn('Panel Dismiss Event: Default Prevented.'); e.preventDefault(); closeGraphWindow() }}
			>
				{graphingOptions.isRendered ? <HighchartsReact
					ref={highchartsRef}
					highcharts={Highcharts}
					options={options}
				/>: null}
			</CalcitePanel>
		</CalciteShellCenterRow>
	);
}

const mapStateToProps = (state) => ({
	graphingOptions: state.graphingOptions
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	closeGraphWindow: () => {dispatch(graphClosed())},
	setGraphIsRendered: () => {dispatch(graphIsRendered())},
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphCenterPanel);
